import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";

export const useSectionNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // If we're on the home page and there's a hash, scroll to it
    if (location.pathname === "/" && location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const navigateToSection = (sectionId: string) => {
    if (location.pathname === "/") {
      // Already on home page, just scroll to section
      const element = document.querySelector(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // Navigate to home page with hash, useEffect will handle scrolling
      navigate(`/${sectionId}`);
    }
  };

  const navigateHome = () => {
    if (location.pathname === "/") {
      // Already on home page, scroll to top
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      // Navigate to home page
      navigate("/");
    }
  };

  return { navigateToSection, navigateHome };
};
